import { css } from "@emotion/react";

export const FeatureNotFoundStyle = {
  wrapper: css`
    padding: 1rem;

    border-radius: 5px;
    border: 2px solid #e96113;

    text-align: center;
  `,
};
